import React from 'react'
import ThreeDotsIcon from '../Assets/Icons/threeDots.svg'
import TeamIcon from '../Assets/Icons/teamIcon.svg'
import PeopleAvatar from '../Assets/PeopleAvatar.jpg'

export default function PeopleCard (props) {
    return(
        <div className='w-[18rem] py-4 px-4 border-[1px] bg-white rounded-[12px] border-[#E5E7EB]' >
            <div className='flex items-center justify-center mt-2'>
            <img className='w-[4.5rem] h-[4.5rem] rounded-full' src={PeopleAvatar} />
            </div>
            <div className='flex items-center justify-center flex-col mt-3'>
                <h2 className='text-[1rem] font-[500] text-[#111928]'>{props.name}</h2>
                <p className='text-[0.90rem] text-[#6B7280]'>{props.location}</p>
            </div>
            <div className='flex items-center justify-center mt-3'>
                <button className='py-1 px-3 flex items-center justify-center gap-2 bg-[#F3F4F6] rounded-[6px] text-[0.90rem]'><img src={TeamIcon} />{props.teamname}</button>
            </div>
        </div>
    );
}